import React from 'react';
import { Settings, Globe, CreditCard, Phone, Truck, Bell } from 'lucide-react';

const AdminSettings = () => {
  return (
    <div dir="rtl" data-testid="admin-settings-section">
      <h2 className="text-xl font-black text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
        <Settings className="w-5 h-5 inline ml-2" />הגדרות
      </h2>

      <div className="space-y-4">
        {/* General */}
        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <h3 className="font-bold text-sm mb-3 flex items-center gap-2"><Globe className="w-4 h-4 text-stone-400" /> כללי</h3>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div><label className="text-xs text-stone-400 block mb-1">שם החנות</label><input defaultValue="בריאות הגבר" className="border rounded-lg px-3 py-2 w-full" /></div>
            <div><label className="text-xs text-stone-400 block mb-1">דומיין</label><input defaultValue="menshealth.co.il" className="border rounded-lg px-3 py-2 w-full" dir="ltr" /></div>
            <div><label className="text-xs text-stone-400 block mb-1">טלפון ראשי</label><input defaultValue="053-940-6051" className="border rounded-lg px-3 py-2 w-full" dir="ltr" /></div>
            <div><label className="text-xs text-stone-400 block mb-1">אימייל</label><input defaultValue="dr.drais.shop@gmail.com" className="border rounded-lg px-3 py-2 w-full" dir="ltr" /></div>
          </div>
        </div>

        {/* Payment */}
        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <h3 className="font-bold text-sm mb-3 flex items-center gap-2"><CreditCard className="w-4 h-4 text-stone-400" /> תשלומים</h3>
          <div className="space-y-2 text-sm">
            <div className="flex items-center justify-between p-2 bg-stone-50 rounded-lg">
              <span>CardCom - כרטיס אשראי</span>
              <span className="text-green-600 text-xs font-bold">מחובר</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-stone-50 rounded-lg">
              <span>Bit - ביט</span>
              <span className="text-green-600 text-xs font-bold">מחובר (CardCom)</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-stone-50 rounded-lg">
              <span>מזומן בעת מסירה</span>
              <span className="text-green-600 text-xs font-bold">פעיל</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-stone-50 rounded-lg">
              <span>העברה בנקאית</span>
              <span className="text-green-600 text-xs font-bold">פעיל</span>
            </div>
          </div>
        </div>

        {/* Bit */}
        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <h3 className="font-bold text-sm mb-3 flex items-center gap-2"><Phone className="w-4 h-4 text-stone-400" /> הגדרות ביט</h3>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div><label className="text-xs text-stone-400 block mb-1">מספר טלפון לביט</label><input defaultValue="0504944192" className="border rounded-lg px-3 py-2 w-full" dir="ltr" /></div>
          </div>
        </div>

        {/* Shipping */}
        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <h3 className="font-bold text-sm mb-3 flex items-center gap-2"><Truck className="w-4 h-4 text-stone-400" /> משלוחים</h3>
          <div className="grid grid-cols-3 gap-3 text-sm">
            <div><label className="text-xs text-stone-400 block mb-1">עלות משלוח רגיל</label><input defaultValue="37" type="number" className="border rounded-lg px-3 py-2 w-full" /></div>
            <div><label className="text-xs text-stone-400 block mb-1">עלות משלוח מזומן</label><input defaultValue="70" type="number" className="border rounded-lg px-3 py-2 w-full" /></div>
            <div><label className="text-xs text-stone-400 block mb-1">עלות משלוח פרטי</label><input defaultValue="0" type="number" className="border rounded-lg px-3 py-2 w-full" /></div>
          </div>
        </div>

        {/* Notifications */}
        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <h3 className="font-bold text-sm mb-3 flex items-center gap-2"><Bell className="w-4 h-4 text-stone-400" /> התראות</h3>
          <div className="space-y-2 text-sm">
            <div className="flex items-center justify-between p-2 bg-stone-50 rounded-lg">
              <span>התראות אימייל</span>
              <span className="text-amber-600 text-xs font-bold">ממתין למפתח Resend</span>
            </div>
            <div className="flex items-center justify-between p-2 bg-stone-50 rounded-lg">
              <span>צ'אטבוט AI</span>
              <span className="text-amber-600 text-xs font-bold">ממתין ליתרה</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
